module.exports = __webpack_public_path__ + "static/media/cny_feast_at_home.e71ad474.jpg";